module.exports = __webpack_public_path__ + "img/cross-primary.b95f9cdd.svg";